import React from 'react'
import moment from 'moment'
import numbro from 'numbro'
import pluralize from 'pluralize'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectLocalisation } from '../../../../store/site'
import { formatDistance, formatDuration, formatElevation } from 'supporticon/utils/fitness'
import currencySymbol from '../../../../lib/currencySymbol'
import withToggle from 'constructicon/with-toggle'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Heading from 'constructicon/heading'
import Icon from 'constructicon/icon'

const Activity = ({
  activityType,
  amount,
  caption,
  classNames,
  country,
  createdAt,
  customFitnessType,
  distance,
  duration,
  elevation,
  isCustom,
  name,
  onToggleOn,
  styles,
  type,
  uom
}) => {
  const fitnessType = () => {
    if (isCustom) {
      return customFitnessType
    }

    switch (type) {
      case 'bike':
        return 'ride'
      case 'walk':
      case 'run':
      case 'ride':
      case 'swim':
      case 'hike':
        return type
      default:
        return 'run'
    }
  }

  const renderIcon = () => {
    switch (activityType) {
      case 'fitness':
        return (
          <div className={classNames.icon}>
            <Icon color='light' size={isCustom ? 1 : 1.333} name={isCustom ? 'heart' : fitnessType()} />
          </div>
        )
      default:
        const currency = currencySymbol(country)
        const icon = currency === '£' ? 'pound' : currency === '€' ? 'euro' : 'dollar'

        return (
          <div className={classNames.icon}>
            <Icon color='light' name={icon} />
          </div>
        )
    }
  }

  const renderContent = () => {
    switch (activityType) {
      case 'fitness':
        return (
          <div className={classNames.content}>
            <Heading tag='span' size={0}>
              {isCustom ? (
                <span>
                  Logged{' '}
                  {numbro(distance).format('0,0')}{' '}
                  {pluralize(pluralize.singular(customFitnessType), distance)}{'. '}
                </span>
              ) : (
                <span>
                  Logged a{' '}
                  {!!distance && formatDistance(distance, uom === 'mi')}{' '}
                  {fitnessType()}{'. '}
                </span>
              )}
              <small className={classNames.details}>
                {!!duration && `Time: ${formatDuration(duration)}. `}
                {!!elevation && `Elevation: ${formatElevation(elevation, uom === 'mi')}`}
              </small>
            </Heading>
            {!!caption && (
              <div className={classNames.caption} onClick={() => onToggleOn()}>
                {caption}
              </div>
            )}
          </div>
        )
      default:
        return (
          <div className={classNames.content}>
            <Heading tag='span' size={0}>
              {`${name || 'Anonymous'} donated ${numbro(amount).formatCurrency('0,0.[00]')}`}
            </Heading>
          </div>
        )
    }
  }

  return (
    <li className={classNames.root}>
      {renderIcon()}
      {renderContent()}
      <span className={classNames.date}>{!!createdAt && moment(createdAt).fromNow()}</span>
    </li>
  )
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default compose(
  connect(mapStateToProps),
  withToggle,
  withStyles(styles)
)(Activity)
